import { isEmpty, isNull, isUndefined } from "lodash";
import { CurrencyEnum } from "utils/enums/CurrencyEnum";
import { strings } from "utils/localizedStrings";
import { StringFormat } from "./StringFormat";

export class NumberFormat {
  static simNumber(phone: string): string {
    if (!isEmpty(phone) && phone != null) {
      return phone.replace(/(\d{4})(\d{3})(\d{3})/, "$1 $2 $3");
    } else {
      return "";
    }
  }

  static generateCaptcha = (length: number): string =>
    Array.from({ length }, () => {
      const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      return characters.charAt(Math.floor(Math.random() * characters.length));
    }).join("");

  static currencyFormat(
    value: number | string,
    needCurrency: boolean = true,
    currencyType?: CurrencyEnum,
  ) {
    return !isUndefined(value) && !isNull(value)
      ? `${needCurrency && currencyType === 1 ? CurrencyEnum?.[currencyType] : ""}${new Intl.NumberFormat(
          "en-US",
        ).format(
          (value as number) || StringFormat.isFloatInString(value as string),
        )} ${(needCurrency && currencyType === 0) || (needCurrency && !currencyType) ? CurrencyEnum?.[currencyType] || CurrencyEnum?.[0] : ""}`
      : strings.GlobalLabels.NoInfo;
  }

  static toRawNumber(value: number | string) {
    return new Intl.NumberFormat("de-DE", {
      style: "decimal",
    }).format(
      (value as number) || parseFloat((value as string).replace(/[^\d]/g, "")),
    );
  }

  static formatChangeRate = (rate?: number) => {
    if (rate === undefined || rate === null) return "";
    const sign = rate >= 0 ? "+" : "";
    return `${sign}${rate.toFixed(1)}%`;
  };

  static handleKeyDown = (event) => {
    const allowedKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Tab",
      "Enter",
    ];
    if (!/^\d$/.test(event.key) && !allowedKeys.includes(event.key)) {
      // Prevent the default action for non-numeric and non-utility keys
      event.preventDefault();
    }
  };

  static CurrentCurrency = "VND";
}
